import React, { useContext, useState } from 'react';
import { Button, Col, Container, Row, ToggleButton } from 'react-bootstrap';

import PrivilegeContext from '../../Contexts/PrivilegeContext';
import { BusinessUnit } from '../../Types/BusinessUnit';

interface CommonConfigPageProps {
    title: string,
    Table: React.FC<{showEditDialog: Function, includeDeleted:boolean, refresh:number, setFilters:any  }>,
    Dialog: React.FC<any>,
    getNewConfigObject?: () => any;
    pageMetaDataLabel?: string;
    pageMetaData?: any,
    businessUnits?: BusinessUnit[],
    children?: React.JSX.Element,
    setFilters?: any
}

function CommonConfigPage({ title, Table, Dialog, getNewConfigObject, pageMetaDataLabel, pageMetaData, businessUnits, children, setFilters }: CommonConfigPageProps) {

    if (!title) {
        console.warn("Prop 'title' is used as an identifier in this component. Please supply the prop with a value.");
    }

    const [includeDeleted, setIncludeDeleted] = useState(false);
    const [refreshToken, setRefreshToken] = useState(0);
    const [showDialog, setShowDialog] = useState(false);
    const [dialogData, setDialogData] = useState({ name: "" });

    const { canConfigure } = useContext(PrivilegeContext);

    const showEditDialog = (dialogData:any) => {
        setDialogData(dialogData);
        setShowDialog(true);
    };

    const showNewDialog = () => {
        if (getNewConfigObject) {
            setDialogData(getNewConfigObject());
        }
        setShowDialog(true);
    };

    const closeDialog = () => {
        setShowDialog(false);
        setRefreshToken(refreshToken + 1);
    };

    return (
        <Container fluid="xs" className="mb-3">
            <Row>
                <Col>
                    {!!pageMetaData &&
                        <div className="d-flex justify-content-end text-secondary">
                            <span className="me-1">{pageMetaDataLabel}</span>
                            <span>{pageMetaData}</span>
                        </div>
                    }
                    <Table includeDeleted={includeDeleted} showEditDialog={showEditDialog} refresh={refreshToken} setFilters={setFilters} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <ToggleButton
                        className="mb-2 float-start"
                        id={"toggle-check-" + title.toLowerCase().replaceAll(' ', '')}
                        type="checkbox"
                        variant="outline-primary"
                        checked={includeDeleted}
                        value="1"
                        onChange={e => setIncludeDeleted(e.currentTarget.checked)}
                    >
                        Include Deleted
                    </ToggleButton>
                    {children}
                    {!!getNewConfigObject &&
                        <Button className="float-end" variant="primary" disabled={!canConfigure} onClick={showNewDialog}>Add</Button>
                    }
                </Col>
            </Row>

            <Dialog dialogData={dialogData} setDialogData={setDialogData} showDialog={showDialog} closeDialog={closeDialog} businessUnits={businessUnits} />

        </Container>
    );
}

export default CommonConfigPage;